import { RefreshService } from 'src/app/services/refresh/refresh.service';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Product } from 'src/app/shared/interface';
import { RefreshValue } from 'src/app/shared/enum';
const FAV = "favorite"
@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  favorites:Product[]= []
  constructor(
    private storage:Storage,
    private refreshService:RefreshService
  ) { }


  async reloadFavorite():Promise<void> {
    const favorite = await this.storage.get(FAV) || [];
    this.favorites = favorite;
  };

  async updateFavorite(product:Product):Promise<void> {
    product.inFav = product.inFav ? false : true;
    if(!product.inFav) {
      this.favorites = this.favorites.filter(fav => fav._id != product._id);
    }else{
      this.favorites.push(product);
    }
    this.refreshService.refresh = RefreshValue.FAVORITE;
    await this.saveFavorite();
  }


  private async saveFavorite():Promise<void> {
    await this.storage.set(FAV, this.favorites);
  }

  getProductFavorite(product:Product):void {
    const filter = this.favorites.filter(fav => fav._id == product._id);
    product.inFav = filter.length == 1;
  }


}
